import AxiosAdminAPI from "../../../../util/AxiosAdminAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {V1AccountUserRoleIDOCToArray} from "../../../../util/Payload";
import {v4 as uuidv4} from "uuid";

class AccountUserRoleEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? "v1.AccountUser-004";

        let QBE = {
            "PlatformMessage": {
                "-idoc": idocResponse,
                "-id": uuidv4(),
                "AccountUser": {
                    "_attributes": {
                        "limit": 1,
                        "sort": null,
                        "offset": 0
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "QG1",
                                "Type": "QueryGroup",
                                "Operator": "AND",
                                "Membership": {
                                    "Member": [
                                        {
                                            "Type": "Attribute",
                                            "Name": "USID",
                                            "Value": foreignKey,
                                            "Operator": "EQUAL"
                                        }
                                    ]
                                }
                            }
                        ]
                    },
                    "Role": {
                        "_attributes": {
                            "limit": pageSize,
                            "sort": this.getFormattedSortSpecification(),
                            "offset": (page - 1) * pageSize
                        },
                        "QueryGroups": {
                            "QueryGroup": [
                                {
                                    "Name": "primary",
                                    "Operator": "AND",
                                    "Type": "QueryGroup",
                                    "Membership": {
                                        "Member": []
                                    }
                                }
                            ]
                        }
                    }
                }
            }
        }

        let queryPayload = this.prepareQueryPayload();

        if (queryPayload.size > 0) {
            for (const [key, value] of queryPayload) {
                if (key.includes("_query")) continue;

                let operator = "EQUAL";
                if (queryPayload.get(key + "_query") !== undefined) {
                    operator = queryPayload.get(key + "_query")
                }
                QBE.PlatformMessage.AccountUser.Role.QueryGroups.QueryGroup[0].Membership.Member.push({
                    "Type": "Attribute",
                    "Name": key,
                    "Value": value,
                    "Operator": operator
                })
            }
        }

        AxiosAdminAPI({
            method: "GET",
            url: "t6/v1/account_users",
            json: true,
            params: {
                "QBE": btoa(JSON.stringify(QBE))
            },
            headers: {
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1AccountUserRoleIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let employee = {};

        employee["USID"] = this.getEnterpriseObject().getEnterpriseComponent("AccountUser").getAttributeValue("USID");
        employee["Role"] = {
            "USID": this.getAttributeValue("USID")
        }

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.AccountUser-004";
        payload.PlatformMessage.AccountUser = employee;

        return payload;
    }

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "PUT",
            url: "t6/v1/account_users",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AccountUser-004",
                "idoc-response": "v1.AccountUser-004"
            },
        };
        this.notifyInsertStartListeners();
        AxiosAdminAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1AccountUserRoleIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    performDelete() {
        let payload = {
            "PlatformMessage": {
                "-idoc": "v1.AccountUser-004",
                "AccountUser": {
                    "_attributes": {
                        "delete": false
                    },
                    "USID": this.getEnterpriseObject().getEnterpriseComponent("AccountUser").getAttributeValue("USID"),
                    "Role": {
                        "_attributes": {
                            "delete": true
                        },
                        "USID": this.getAttributeValue("USID")
                    }
                }
            }
        }

        let options = {
            method: "DELETE",
            url: "t6/v1/account_users",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AccountUser-004"
            },
        };
        this.notifyDeleteStartListeners();
        AxiosAdminAPI(options)
            .then(() => {
                this.deleteEnterpriseComponentSuccess();
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };
}

export default AccountUserRoleEnterpriseComponent;